<div nz-col nzSpan="24">
  <nz-card>
    <form nz-form [nzNoColon]="true">
      <nz-form-label class="nfl-form-label"> {{ title }} </nz-form-label>

      <div class="input-wrapper">
        <nz-spin [nzSpinning]="isLoading">
          <nz-upload
            nzType="drag"
            [nzMultiple]="true"
            [(nzFileList)]="fileList"
            [nzBeforeUpload]="beforeUpload"
            [nzAccept]="allowedExtensions.join(',')"
            nzListType="picture"
            class="upload"
          >
            <p class="upload-drag-icon">
              <span nz-icon nzType="cloud-upload" class="ant-upload-drag-icon"></span>
            </p>
            <p class="ant-upload-text">Click or drag file to this area to upload</p>
            <p class="ant-upload-hint">Support for a single or bulk upload</p>
          </nz-upload>
        </nz-spin>
        <nz-progress *ngIf="progressRatio > 0" [nzPercent]="progressRatio"></nz-progress>
        <button
          nz-button
          [nzType]="'primary'"
          [nzLoading]="uploading"
          (click)="handleUpload()"
          [disabled]="fileList.length === 0"
          class="upload-btn"
          *ngIf="!(parent === 'data-connection')"
        >
          {{ uploading ? 'Uploading' : 'Export File(s)' }}
        </button>
      </div>
    </form>
  </nz-card>
</div>
